module.exports = __webpack_public_path__ + "static/media/dumpster.a191f962.svg";